import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HeaderTitleComponent } from './components/header-title/header-title.component';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  declarations: [HeaderTitleComponent],
  exports: [HeaderTitleComponent],
})
export class SharedModule { }
